import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';

import Header from "./Header";
import Sidebar from "./Sidebar";
import { useSelector, useDispatch } from 'react-redux'

import { GET, httpOk } from 'helpers/api'

function Layout() {
	const dispatch = useDispatch()
	const layoutSelector = useSelector(state => state.layout)
	const reduxAccount = useSelector(state => state.account)

	// Ruxsatlarni ilova ochilganda qayta olamiz.
	// Sabab: super-admin biznes tarifini o'zgartirsa (masalan START -> PRO), foydalanuvchi
	// chiqib-kirmasdan, sahifani yangilagach (F5) yangi bo'limlarni ko'radi.
	useEffect(() => {
		async function refreshPermissions() {
			const response = await GET('/helper/my-permissions', {}, { loader: false })
			if (httpOk(response) && Array.isArray(response.data)) {
				dispatch({ type: 'CHANGE_ACCOUNT', payload: { ...reduxAccount, permissions: response.data } })
			}
		}
		refreshPermissions()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div id="layout-wrapper">
			<Header />
			<Sidebar />
			<div className={"main-content " + (layoutSelector.showleftMenu ? 'sidebar-active-margin' : 'sidebar-margin')}>
				<div className="page-content">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

export default Layout
